export default "__VITE_ASSET__l__yzLwr__"